export enum ContactsAnalyticsEvents {
  ContactSelected = 'slctd',
  ContactSearchInputPhoneNumberClicked = 'srch_inpt_phone_num_clkd',
  ContactSearchInputExtensionClicked = 'srch_inpt_ext_clkd',
  ContactQuickActionClicked_Call = 'qck_act_clkd_call',
  ContactQuickActionClicked_Message = 'qck_act_clkd_msg',
  ContactQuickActionClicked_Fax = 'qck_act_clkd_fax',
  ContactQuickActionClicked_Link = 'qck_act_clkd_link',
  ContactDetailActionClicked_Call = 'dtl_act_clkd_call',
  ContactDetailActionClicked_Message = 'dtl_act_clkd_msg',
  ContactDetailActionClicked_Fax = 'dtl_act_clkd_fax',
  ContactDetailActionClicked_Copy = 'dtl_act_clkd_cpy',
}
